import { render, staticRenderFns } from "./dms.vue?vue&type=template&id=04d57deb"
import script from "./dms.ts?vue&type=script&lang=js&external"
export * from "./dms.ts?vue&type=script&lang=js&external"
import style0 from "./dms.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports